var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import { applyActionCode, verifyPasswordResetCode, confirmPasswordReset, reload, checkActionCode, } from 'firebase/auth';
import { useAuth } from '../../context/AuthContext';
import { Card } from '../UI/Card';
import { Button } from '../UI/Button';
import { LoadingSpinner } from '../UI/LoadingSpinner';
import { Mail, KeyRound, AlertCircle, CheckCircle2 } from 'lucide-react';
var ActionHandler = function () {
    var navigate = useNavigate();
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(null), success = _c[0], setSuccess = _c[1];
    var _d = useState(null), emailForReset = _d[0], setEmailForReset = _d[1];
    var _e = useState(''), newPassword = _e[0], setNewPassword = _e[1];
    var _f = useState(false), confirming = _f[0], setConfirming = _f[1];
    var _g = useAuth(), resendVerificationEmail = _g.resendVerificationEmail, currentUser = _g.currentUser;
    var _h = useState(false), resending = _h[0], setResending = _h[1];
    var _j = useState(false), resent = _j[0], setResent = _j[1];
    var _k = useState(null), resendError = _k[0], setResendError = _k[1];
    var _l = useState(0), cooldown = _l[0], setCooldown = _l[1];
    useEffect(function () {
        if (cooldown <= 0)
            return;
        var t = setTimeout(function () { return setCooldown(function (c) { return c - 1; }); }, 1000);
        return function () { return clearTimeout(t); };
    }, [cooldown]);
    var params = useMemo(function () { return new URLSearchParams(window.location.search); }, []);
    var mode = params.get('mode');
    var oobCode = params.get('oobCode');
    var rawContinue = params.get('continueUrl');
    // Sanitize continueUrl: must be same-origin, non-auth/action loop, returns relative path
    var safeContinue = useMemo(function () {
        if (!rawContinue)
            return '/';
        try {
            var url = new URL(rawContinue, window.location.origin);
            if (url.origin !== window.location.origin)
                return '/';
            var path = url.pathname + url.search + url.hash;
            if (path.startsWith('/auth/action'))
                return '/';
            return path || '/';
        }
        catch (_a) {
            return '/';
        }
    }, [rawContinue]);
    useEffect(function () {
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var preErr_1, _a, email, e_1, code, friendly;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!mode || !oobCode) {
                            setError('Invalid or missing action parameters.');
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 17, 18, 19]);
                        if (!(mode === 'verifyEmail')) return [3 /*break*/, 13];
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, checkActionCode(auth, oobCode)];
                    case 3:
                        _c.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        preErr_1 = _c.sent();
                        // If user already verified, treat as success
                        if (auth.currentUser && auth.currentUser.emailVerified) {
                            setSuccess('Your email is already verified.');
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        throw preErr_1;
                    case 5: return [4 /*yield*/, applyActionCode(auth, oobCode)];
                    case 6:
                        _c.sent();
                        if (!auth.currentUser) return [3 /*break*/, 11];
                        _c.label = 7;
                    case 7:
                        _c.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, reload(auth.currentUser)];
                    case 8:
                        _c.sent();
                        return [3 /*break*/, 10];
                    case 9:
                        _a = _c.sent();
                        return [3 /*break*/, 10];
                    case 10:
                        if (auth.currentUser.emailVerified) {
                            setSuccess('Your email has been verified. You can continue using the app.');
                        }
                        else {
                            setSuccess('Verification processed. If status has not updated, try refreshing.');
                        }
                        return [3 /*break*/, 12];
                    case 11:
                        setSuccess('Email verified. You may sign in now.');
                        _c.label = 12;
                    case 12: return [3 /*break*/, 16];
                    case 13:
                        if (!(mode === 'resetPassword')) return [3 /*break*/, 15];
                        return [4 /*yield*/, verifyPasswordResetCode(auth, oobCode)];
                    case 14:
                        email = _c.sent();
                        setEmailForReset(email);
                        return [3 /*break*/, 16];
                    case 15:
                        setError('Unsupported action.');
                        _c.label = 16;
                    case 16: return [3 /*break*/, 19];
                    case 17:
                        e_1 = _c.sent();
                        code = (e_1 === null || e_1 === void 0 ? void 0 : e_1.code) || '';
                        friendly = (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || 'The link is invalid or has expired.';
                        if (code === 'auth/invalid-action-code')
                            friendly = 'This link is invalid, expired, or already used. You may request a new one.';
                        if (code === 'auth/expired-action-code')
                            friendly = 'This link has expired. Please request a new one.';
                        if (code === 'auth/user-disabled')
                            friendly = 'This account is disabled.';
                        if (code === 'auth/user-not-found')
                            friendly = 'User associated with this link was not found.';
                        // If already verified despite error
                        if (mode === 'verifyEmail' && ((_b = auth.currentUser) === null || _b === void 0 ? void 0 : _b.emailVerified)) {
                            setSuccess('Your email is already verified.');
                        }
                        else {
                            setError(friendly);
                        }
                        return [3 /*break*/, 19];
                    case 18:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 19: return [2 /*return*/];
                }
            });
        }); };
        run();
    }, [mode, oobCode]);
    var handleConfirmPassword = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!oobCode)
                        return [2 /*return*/];
                    setConfirming(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, confirmPasswordReset(auth, oobCode, newPassword)];
                case 2:
                    _a.sent();
                    setSuccess('Password updated. You can now sign in with your new password.');
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    setError((e_2 === null || e_2 === void 0 ? void 0 : e_2.message) || 'Failed to set the new password.');
                    return [3 /*break*/, 5];
                case 4:
                    setConfirming(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var passwordStrength = useMemo(function () {
        if (!newPassword)
            return 0;
        var score = 0;
        if (newPassword.length >= 6)
            score++;
        if (newPassword.length >= 10)
            score++;
        if (/[A-Z]/.test(newPassword))
            score++;
        if (/[0-9]/.test(newPassword))
            score++;
        if (/[^A-Za-z0-9]/.test(newPassword))
            score++;
        return Math.min(score, 5);
    }, [newPassword]);
    var strengthLabel = ['Too weak', 'Weak', 'Fair', 'Good', 'Strong', 'Very strong'][passwordStrength];
    if (loading) {
        return (_jsx("div", __assign({ className: "min-h-[70vh] flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-slate-100 dark:from-gray-900 dark:via-gray-950 dark:to-gray-900" }, { children: _jsxs("div", __assign({ className: "flex flex-col items-center space-y-4" }, { children: [_jsx(LoadingSpinner, { size: "lg" }), _jsx("p", __assign({ className: "text-sm text-muted-foreground dark:text-muted-foreground" }, { children: "Processing secure action..." }))] })) })));
    }
    return (_jsxs("div", __assign({ className: "min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex flex-col" }, { children: [_jsx("header", __assign({ className: "w-full p-4 lg:p-6" }, { children: _jsx("div", __assign({ className: "max-w-6xl mx-auto flex items-center justify-center" }, { children: _jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx("img", { src: "/logo.png", alt: "LectureLearn", className: "h-8 w-8", onError: function (e) { e.currentTarget.style.display = 'none'; } }), _jsx("span", __assign({ className: "text-xl font-bold text-foreground dark:text-white" }, { children: "LectureLearn" }))] })) })) })), _jsx("main", __assign({ className: "flex-1 flex items-center justify-center p-4 lg:p-6 overflow-y-auto" }, { children: _jsx("div", __assign({ className: "w-full max-w-md my-8" }, { children: _jsxs(Card, __assign({ className: "w-full overflow-hidden shadow-lg border border-border dark:border-border" }, { children: [_jsxs("div", __assign({ className: "bg-gradient-to-r from-indigo-600 via-violet-600 to-fuchsia-600 px-6 py-8 text-center" }, { children: [_jsxs("div", __assign({ className: "w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4" }, { children: [mode === 'verifyEmail' && _jsx(Mail, { className: "h-7 w-7 text-white" }), mode === 'resetPassword' && _jsx(KeyRound, { className: "h-7 w-7 text-white" })] })), _jsx("h1", __assign({ className: "text-2xl font-semibold tracking-tight text-white" }, { children: mode === 'verifyEmail' ? 'Verify Your Email' : mode === 'resetPassword' ? 'Reset Password' : 'Account Action' })), _jsx("p", __assign({ className: "text-xs text-white/80 mt-1" }, { children: mode === 'verifyEmail' ? 'Secure your account & unlock all features' : mode === 'resetPassword' ? 'Choose a strong new password' : 'Continue with your action' }))] })), _jsxs("div", __assign({ className: "p-6" }, { children: [error && (_jsxs("div", __assign({ className: "flex items-start space-x-2 bg-error-muted dark:bg-error-muted/20 border border-error/20 dark:border-error text-error dark:text-error px-4 py-3 rounded mb-4 text-sm" }, { children: [_jsx(AlertCircle, { className: "h-4 w-4 mt-0.5 flex-shrink-0" }), _jsx("span", { children: error })] }))), success && (_jsxs("div", __assign({ className: "flex items-start space-x-2 bg-success-muted dark:bg-success-muted/20 border border-success/20 dark:border-success text-success dark:text-success px-4 py-3 rounded mb-4 text-sm" }, { children: [_jsx(CheckCircle2, { className: "h-4 w-4 mt-0.5 flex-shrink-0" }), _jsx("span", { children: success })] }))), mode === 'verifyEmail' && !success && error && currentUser && !currentUser.emailVerified && (_jsxs("div", __assign({ className: "mb-4 space-y-2" }, { children: [_jsx(Button, __assign({ variant: "outline", className: "w-full", disabled: resending || cooldown > 0, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                    var e_3;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                if (resending || cooldown > 0)
                                                                    return [2 /*return*/];
                                                                setResendError(null);
                                                                setResending(true);
                                                                _a.label = 1;
                                                            case 1:
                                                                _a.trys.push([1, 3, 4, 5]);
                                                                return [4 /*yield*/, resendVerificationEmail()];
                                                            case 2:
                                                                _a.sent();
                                                                setResent(true);
                                                                setCooldown(45);
                                                                return [3 /*break*/, 5];
                                                            case 3:
                                                                e_3 = _a.sent();
                                                                setResendError((e_3 === null || e_3 === void 0 ? void 0 : e_3.message) || 'Failed to resend');
                                                                return [3 /*break*/, 5];
                                                            case 4:
                                                                setResending(false);
                                                                return [7 /*endfinally*/];
                                                            case 5: return [2 /*return*/];
                                                        }
                                                    });
                                                }); } }, { children: resending ? (_jsxs("div", __assign({ className: "flex items-center justify-center gap-2" }, { children: [_jsx(LoadingSpinner, { size: "sm" }), _jsx("span", { children: "Sending\u2026" })] }))) : cooldown > 0 ? ("Resend in ".concat(cooldown, "s")) : ('Resend Verification Email') })), resent && !resendError && (_jsx("p", __assign({ className: "text-sm text-success dark:text-success text-center" }, { children: "Email sent. Check your inbox." }))), resendError && (_jsx("p", __assign({ className: "text-sm text-error dark:text-error text-center" }, { children: resendError })))] }))), mode === 'resetPassword' && emailForReset && !success && (_jsxs("form", __assign({ onSubmit: handleConfirmPassword, className: "space-y-5" }, { children: [_jsxs("div", __assign({ className: "space-y-2" }, { children: [_jsx("p", __assign({ className: "text-xs font-medium uppercase tracking-wide text-indigo-600 dark:text-indigo-400" }, { children: "Account" })), _jsxs("p", __assign({ className: "text-sm text-muted-foreground dark:text-muted-foreground" }, { children: ["Reset password for ", _jsx("span", __assign({ className: "font-medium text-foreground dark:text-muted-foreground" }, { children: emailForReset }))] }))] })), _jsxs("div", __assign({ className: "space-y-2" }, { children: [_jsx("label", __assign({ className: "block text-sm font-medium" }, { children: "New Password" })), _jsx("input", { type: "password", value: newPassword, onChange: function (e) { return setNewPassword(e.target.value); }, className: "w-full px-3 py-2 border border-border dark:border-border rounded focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-muted", minLength: 6, required: true, autoFocus: true, placeholder: "Enter new password" }), newPassword && (_jsxs("div", __assign({ className: "space-y-1" }, { children: [_jsx("div", __assign({ className: "h-2 w-full bg-muted dark:bg-muted rounded overflow-hidden" }, { children: _jsx("div", { className: "h-full transition-all ".concat(passwordStrength <= 1 ? 'bg-error w-1/5' :
                                                                        passwordStrength === 2 ? 'bg-warning w-2/5' :
                                                                            passwordStrength === 3 ? 'bg-warning w-3/5' :
                                                                                passwordStrength === 4 ? 'bg-success w-4/5' : 'bg-success w-full') }) })), _jsxs("p", __assign({ className: "text-xs text-muted-foreground dark:text-muted-foreground" }, { children: ["Strength: ", strengthLabel] }))] }))), _jsxs("ul", __assign({ className: "text-xs text-muted-foreground dark:text-muted-foreground space-y-1 mt-1" }, { children: [_jsx("li", __assign({ className: newPassword.length >= 6 ? 'text-success dark:text-success' : '' }, { children: "6+ characters" })), _jsx("li", __assign({ className: /[A-Z]/.test(newPassword) ? 'text-success dark:text-success' : '' }, { children: "Uppercase letter" })), _jsx("li", __assign({ className: /[0-9]/.test(newPassword) ? 'text-success dark:text-success' : '' }, { children: "Number" }))] }))] })), _jsx(Button, __assign({ type: "submit", disabled: confirming, className: "w-full h-11 font-medium" }, { children: confirming ? 'Updating...' : 'Update Password' }))] }))), _jsxs("div", __assign({ className: "mt-8 space-y-3" }, { children: [_jsx(Button, __assign({ variant: success ? 'secondary' : 'outline', className: "w-full h-11 font-medium", onClick: function () { return navigate(safeContinue); } }, { children: success ? 'Continue to LectureLearn' : 'Back to LectureLearn' })), mode === 'verifyEmail' && !success && (_jsx("p", __assign({ className: "text-xs text-muted-foreground dark:text-muted-foreground text-center" }, { children: "Didn\u2019t get the email? Check spam or request a new link from your account page." })))] }))] }))] })) })) }))] })));
};
export default ActionHandler;
